var SENTRY_RELEASE;SENTRY_RELEASE={name: "TaskScribe", version: "0.1.0"};